import { TableCellNode, TableNode } from '@lexical/table';
import { DEFAULT_NODES } from '../../defaultNodes';
import { $createRawHtmlTableNode, RawHtmlTableNode } from './RawHtmlTableNode';
import { $createRawHtmlTableCellNodeFrom, RawHtmlTableCellNode } from './RawHtmlTableCellNode';

export const RAW_HTML_TABLE_NODES =
[
    ...DEFAULT_NODES.filter(node => node !== TableNode && node !== TableCellNode),

    RawHtmlTableNode,
    RawHtmlTableCellNode,

    {
        replace: TableNode,
        with: () => $createRawHtmlTableNode(),
        withKlass: RawHtmlTableNode,
    },

    {
        replace: TableCellNode,
        with: (node: TableCellNode) => $createRawHtmlTableCellNodeFrom(node),
        withKlass: RawHtmlTableCellNode,
    },
];